import React, {useContext, useEffect, useMemo, useState} from 'react';
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FilterDropdown from "../FilterDropdown.jsx";
import {faHouse} from "@fortawesome/free-solid-svg-icons";
import {useErrorTranslation} from "../../api/utilities/translateErrorMessage.js";
import {FilterContext} from "./DashboardFilterContextProvider.jsx";
import Select from "react-select";
import Badge from "../Badge.jsx";

export default function OrderCentreFilter() {
    let {t} = useTranslation();

    let {centresPossible, centresAllowListed, setCentresAllowListed, domainsAllowListed} = useContext(FilterContext);

    let [selectOpened, setSelectOpened] = useState(false);

    let {et} = useErrorTranslation();

    let {selectValue, selectOptions, selectedAmount, possibleAmount} = useMemo(() => {
        let selectValue = [];
        let selectOptions = [];
        let selectedAmount = 0;
        let possibleAmount = 0;

        for (let possibleCentre of centresPossible) {
            possibleAmount++;

            let centreName =  '[' + possibleCentre.projectCentre.slug + '] ' + possibleCentre.projectCentre.name;

            if (centresAllowListed.includes(possibleCentre.projectCentre.id)) {
                selectedAmount++;
                selectValue.push({
                    value: possibleCentre.projectCentre.id,
                    label: centreName,
                });
            }

            selectOptions.push({
                value: possibleCentre.projectCentre.id,
                label: centreName,
            });
        }

        return {
            selectValue: selectValue,
            selectOptions: selectOptions,
            selectedAmount: selectedAmount,
            possibleAmount: possibleAmount,
        };

    }, [centresPossible, centresAllowListed]);

    if( Object.keys(centresPossible).length < 2 && domainsAllowListed.length === 0) {
        return null;
    }

    return (<FilterDropdown
        title={t('filter.centres')}
        align={'right'}
        button={<div className={'flex justify-center items-center text-nowrap gap-2'}>
            <FontAwesomeIcon icon={faHouse}/>
            {t('filter.centres')}
            {(selectedAmount !== 0 && selectedAmount < possibleAmount) && <Badge>{selectedAmount}/{possibleAmount}</Badge>}
        </div>}
        inhibitClosing={selectOpened}
    >
        <ul>
            <Select
                isMulti
                options={selectOptions}
                value={selectValue}
                menuPortalTarget={document.body}
                menuPosition='fixed'
                noOptionsMessage={() => t('filter.no-centres-found')}
                onMenuOpen={() => setSelectOpened(true)}
                onMenuClose={() => setTimeout(() => setSelectOpened(false), 100)}
                onChange={(val) => setCentresAllowListed(val.map((obj) => obj.value))}
                className={'datixo_select_container w-96'}
                classNamePrefix={'datixo_select'}
            />
        </ul>
    </FilterDropdown>);
}
